import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import Section from 'components/ui/general/Section';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ImageIcon } from 'assets/materialIcons/materialIcons';
import DeleteButton from 'components/button/DeleteButton';
import { deleteMembershipPool } from 'store/actions/membership-pools/deleteMembershipPools';

const MembershipPoolShow = (props) => {
    const {
        id,
        history,
        record,
        resource,
        translate,
    } = props;

    const breadcrumbs = [
        {
            label: translate('menu.sidebar.membership_pools'),
            link: '/membership-pools',
        },
        {
            label: record.name,
        },
    ];

    const onDeleteMembershipPool = () => {
        return deleteMembershipPool({
            id,
            onSuccess: () => {
                return history.push('/membership-pools');
            },
        });
    };

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ record.name }/>

                <Actions>
                    <EditButton
                        icon={ <ImageIcon color={ theme.palette.doveGray } /> }
                        url={ `/${ resource }/${ id }` }
                    />

                    <DeleteButton action={ onDeleteMembershipPool } record={ record } />
                </Actions>
            </Header>

            <Section>
                <Column title={ translate('resources.discounts.forms.general') }>
                    <InnerColumn>
                        <TextField
                            label={ translate('filters.components.name.label') }
                            value={ record.name }
                        />

                        <TextField
                            label={ translate('fields.size') }
                            value={ record.size }
                        />
                    </InnerColumn>
                </Column>
            </Section>
        </div>
    );
};

MembershipPoolShow.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }),
    id: PropTypes.number,
    record: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(MembershipPoolShow);



// WEBPACK FOOTER //
// ./src/pages/membership-pools/show/MembershipPoolShow.js